import { runInAction } from 'mobx';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
export const clearInProgressItems = () => {
    runInAction(() => {
        temporaryOrderDomainStore.data.inProgressItems = [];
    });
};
